/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shopping_Recipe_AddInputs */

const en_shopping_recipe_add = /** @type {(inputs: Shopping_Recipe_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a recipe`)
};

const de_shopping_recipe_add = /** @type {(inputs: Shopping_Recipe_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezept hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add a recipe" |
*
* @param {Shopping_Recipe_AddInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shopping_recipe_add = /** @type {((inputs?: Shopping_Recipe_AddInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shopping_Recipe_AddInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_shopping_recipe_add(inputs)
	return en_shopping_recipe_add(inputs)
});